import { useEffect } from 'react';

import validate from './RevokeSSRPFormValidation';

import UseForm from '@usas/ui-web/utils/UseForm';
import { BLANK_DATE_STRING } from '@usas/ui-web/utils/Constants';
import { formatDate } from '@usas/ui-web/utils/DateFunctions';

const INITIAL_FORM_STATE = {
  expirationDate: BLANK_DATE_STRING
};

const useRevokeSSRPForm = (onSubmitFormCallback, effectiveDate) => {
  const { formState, errorState, handleSubmit, updateFormState, setFormData,
  } = UseForm(INITIAL_FORM_STATE, onSubmitFormCallback, validate);

  useEffect(() => {
    const today = formatDate(new Date());

    setFormData({
      ...formState,
      effectiveDate: formatDate(effectiveDate),
      expirationDate: today
    }, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    formState,
    errorState,
    handleSubmit,
    updateFormState
  };
};

export default useRevokeSSRPForm;